import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
// import logger from "redux-logger";
import modalReducer from './redux/modalReducer';
import homeReducer from './redux/homeReducer';
import sideBarReducer from './redux/sideBarReducer';
import fabricCanvasReducer from './redux/fabricCanvasReducer';
import finalCheckReducer from './redux/finalCheckReducer';
import pageControllerReducer from './redux/pageControllerReducer';
import vanillaDesignReducer from './redux/vanillaDesignReducer';

// const composeEnhancers =
//   process.env.NODE_ENV === 'production'
//     ? null
//     : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // This is added for debugging purpose using Redux Dev tools

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // This is added for debugging purpose using Redux Dev tools

const combinedStore = createStore(
  combineReducers({
    modal: modalReducer,
    home: homeReducer,
    sideBar: sideBarReducer,
    fabricCanvas: fabricCanvasReducer,
    finalCheck: finalCheckReducer,
    pageController: pageControllerReducer,
    vanilla: vanillaDesignReducer
  }),
  composeEnhancers(applyMiddleware(thunk)) // Thunk : Middleware used for Asynchronous redux state updates
);

export default combinedStore;
